<template>
  <div class="container">

    <div v-if="!results" class="empty">
      <p class="empty-title h5">There are no VEVO results for this client</p>

      <div v-if="!validProfile">
        <dl>
          <dt v-if="!okDOB">Invalid date of birth</dt>
          <dt v-if="!okCountry">No country</dt>
          <dt v-if="!okPassport">No passport number</dt>
        </dl>
      </div>

      <div v-else class="empty-action">
        <button @click="submit" class="btn btn-primary" :class="{loading: loading}">Perform search</button>
      </div>
    </div>

    <div v-else>
      <div class="columns">
        <div class="col-3 col-sm-12">Date of search</div>
        <div class="col-9 col-sm-12">{{new Date(results.date).toLocaleDateString('en-gb')}}</div>
      </div>
      <div class="columns" v-for="(desc, field) in resultFields">
        <div v-if="results[field]" class="col-3 col-sm-12">{{desc}}</div>
        <div v-if="results[field]" class="col-9 col-sm-12">{{results[field]}}</div>
      </div>

      <div class="columns" v-if="results.conditions">
        <div class="col-3 col-sm-12">Visa conditions</div>
        <div class="col-9 col-sm-12">
          <div v-for="c in results.conditions" v-html="c"></div>
        </div>
      </div>

      <br />
      <button @click="submit" class="btn" :class="{loading: loading}">Update results</button>
      <span v-if="showCalMsg" class="label label-success">Expiry date in calendar</span>
    </div>

    <br />
    <span v-if="message" class="label label-error">{{message}}</span>
    <span v-if="errormsg" class="label label-error">{{errormsg}}</span>

  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'

export default {
  name: 'clientvevo',
  props: ['user'],
  mixins: [utils],
  data () {
    return {
      countries: utils.countries(),
      resultFields: utils.vevoFields(),
      okDOB: false,
      okPassport: false,
      okCountry: false,
      loading: false,
      results: null,
      message: null,
      errormsg: null,
      docType: '01', // PASSPORT
      showCalMsg: false
    }
  },
  created () {
    if (this.user.vevo) {
      this.results = this.user.vevo
    }
    // Validate the user profile
    let p = this.user.profile
    this.okDOB = /^\d{2}-\d{2}-\d{4}$/.test(p.dob)
    this.okPassport = p.passport.trim().length > 0
    this.okCountry = this.countries.hasOwnProperty(p.country)
  },
  computed: {
    validProfile () {
      return this.okDOB && this.okPassport && this.okCountry
    }
  },
  methods: {
    submit () {
      if (this.loading) return
      this.loading = true
      this.showCalMsg = false

      let p = this.user.profile
      const params = new URLSearchParams()

      params.append('dyb_password', process.env.DYB_PASSWORD)
      params.append('familyName', p.lastname)
      params.append('givenName', p.firstname)
      params.append('dob', p.dob)
      params.append('docType', this.docType)
      params.append('docNumber', p.passport)
      params.append('docCountry', this.countries[p.country])

      axios.get(utils.dybURL() + params.toString())
      .then(res => {
        if (res.status === 200) {
          this.loading = false
          if (res.data.success) {
            res.data.date = new Date()
            res.data.expiry = new Date(res.data.visaExpDate)
            this.results = res.data
            this.saveResults()
            this.addToCalendar()
          } else if (res.data.message) {
            this.message = res.data.message
          }
        }
      })
      .catch(e => {
        this.loading = false
        this.errormsg = e.response.data
      })
    },
    saveResults () {
      axios.post('/api/users/savevevo/' + this.user._id, this.results)
      .catch(e => { console.log(e.response.data) })
    },
    // Add the visa expiration date to the admin's calendar
    addToCalendar () {
      if (!this.results.visaExpDate) return
      let p = this.user.profile
      axios.post('/api/events/new', {
        user: this.$root.$data.user._id,
        start: this.results.expiry,
        title: 'Visa expiry - ' + p.firstname + ' ' + p.lastname,
        details: this.results.visaType + ' ' + this.results.visaClass,
        allDay: true,
        hasOwner: false
      })
      .then(res => {
        if (res.status === 200) {
          this.showCalMsg = true
        }
      })
      .catch(e => { console.log(e.response.data) })
    }
  }
}
</script>

<style scoped>
.columns {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// clientvevo.vue?a85dfeb2